module.exports = __webpack_public_path__ + "img/QiaoFu.7837d482.svg";